export type HelpdeskFormsSearch = {
  tenantId?: string;
  category?: string;
  departmentGroup?: string;
  search?: string;
  status?: "draft" | "published";
};

const optionalSearchString = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const helpdeskFormsSearch = (value: Record<string, unknown>): HelpdeskFormsSearch => {
  const status = value.status === "draft" || value.status === "published" ? value.status : undefined;
  return {
    ...(optionalSearchString(value.tenantId) ? { tenantId: optionalSearchString(value.tenantId) } : {}),
    category: optionalSearchString(value.category),
    ...(optionalSearchString(value.departmentGroup) ? { departmentGroup: optionalSearchString(value.departmentGroup) } : {}),
    search: optionalSearchString(value.search),
    status,
  };
};
